import type { UserAttributes } from "hooks/api/use-current-user";

import { Permission, Role } from "types/auth";

export function hasPermission(user: UserAttributes, permission: Permission) {
  return user.permissions.includes(permission);
}

export function hasRole(user: UserAttributes, role: Role) {
  return user.roles.includes(role);
}
